/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} List_Removed_SuccessInputs */

const en_list_removed_success = /** @type {(inputs: List_Removed_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`List removed successfully`)
};

const fr_list_removed_success = /** @type {(inputs: List_Removed_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Liste supprimée avec succès`)
};

const de_list_removed_success = /** @type {(inputs: List_Removed_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Liste erfolgreich entfernt`)
};

const it_list_removed_success = /** @type {(inputs: List_Removed_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Elenco rimosso con successo`)
};

const ru_list_removed_success = /** @type {(inputs: List_Removed_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Список успешно удален`)
};

const es_list_removed_success = /** @type {(inputs: List_Removed_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lista eliminada exitosamente`)
};

const zh_cn2_list_removed_success = /** @type {(inputs: List_Removed_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`列表已成功移除`)
};

const ja_list_removed_success = /** @type {(inputs: List_Removed_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`リストが正常に削除されました`)
};

const hi_list_removed_success = /** @type {(inputs: List_Removed_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`सूची सफलतापूर्वक हटा दी गई`)
};

const pt_pt2_list_removed_success = /** @type {(inputs: List_Removed_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lista removida com sucesso`)
};

/**
* | output |
* | --- |
* | "List removed successfully" |
*
* @param {List_Removed_SuccessInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const list_removed_success = /** @type {((inputs?: List_Removed_SuccessInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<List_Removed_SuccessInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_list_removed_success(inputs)
	if (locale === "de") return de_list_removed_success(inputs)
	if (locale === "it") return it_list_removed_success(inputs)
	if (locale === "ru") return ru_list_removed_success(inputs)
	if (locale === "es") return es_list_removed_success(inputs)
	if (locale === "zh-CN") return zh_cn2_list_removed_success(inputs)
	if (locale === "ja") return ja_list_removed_success(inputs)
	if (locale === "hi") return hi_list_removed_success(inputs)
	if (locale === "pt-PT") return pt_pt2_list_removed_success(inputs)
	return en_list_removed_success(inputs)
});